'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cwUi = require('cw-ui');

var _AutomationName = require('../../services/AutomationName');

var _AutomationName2 = _interopRequireDefault(_AutomationName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @type {React.StatelessComponent} */
var FormField = function FormField(props) {
  var widget = _react2.default.Children.only(props.children);

  var handleChange = function handleChange(value) {
    if (widget.props.onChange) {
      widget.props.onChange(value);
    } else {
      props.onChange(value, props.ignoreDirty);
    }
  };

  var handleSystemChange = function handleSystemChange(value) {
    if (widget.props.onSystemChange) {
      widget.props.onSystemChange(value);
    } else {
      props.onChange(value, false /* system changes does not dirty */);
    }
  };

  return _react2.default.createElement(
    _cwUi.CwFormField,
    {
      cwId: _AutomationName2.default.get('form', props.automationName),
      className: props.className,
      style: props.style,
      label: props.label,
      error: props.error
    },
    _react2.default.cloneElement(widget, {
      automationName: props.automationName,
      value: props.value,
      onChange: handleChange,
      onSystemChange: handleSystemChange,
      invalid: props.invalid
    })
  );
};

FormField.propTypes = (0, _assign2.default)({
  /**
   * Element id used as selection and search for automation testing
   */
  automationName: _propTypes2.default.string,
  /**
   * Used to map data to/from store
   */
  path: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  /**
   * Value to be displayed and manipulated by the widget
   */
  value: _propTypes2.default.any,
  /**
   * Optional hook function fired to allow modification of value on change
   */
  modifyOnChange: _propTypes2.default.func,
  /**
   * Callback function for on change supplied by the container
   */
  onChange: _propTypes2.default.func,
  /**
   * Optional hook function fired after onChange
   */
  onAfterChange: _propTypes2.default.func,
  /**
   * Indicates that the value of the widget is invalid
   */
  invalid: _propTypes2.default.bool,
  /**
   * Used to identify which screen state to modify
   */
  screenKey: _propTypes2.default.string.isRequired,
  /**
   * When false (default), will update the dirty flag onChange
   * in order to later bring up the unsaved data dialog
   */
  ignoreDirty: _propTypes2.default.bool
}, _cwUi.CwFormField.propTypes);

exports.default = FormField;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/formfield/FormField.js
// module id = 328
// module chunks = 10